export const OPEN_COOKIE_SETTINGS_EVENT = "rivetai:open-cookie-settings";

export { openCookieSettings } from "./cookie-settings";
export {
  COOKIE_CONSENT_KEY,
  denyAdsConsent,
  getCookieConsent,
  getStoredCookieConsent,
  hasAdsConsent,
  hasAnalyticsConsent,
  setCookieConsent,
} from "./consent";
export type { CookieConsentValue } from "./consent";
export {
  isRegionalConsentEnabled,
  requiresConsentBanner,
} from "./regional-consent";
export { isMarketingAnalyticsConfigured, marketingAnalyticsEnv } from "./env";
export {
  ensureOpenAiAdsPixel,
  isOpenAiAdsPixelConfigured,
  measureOpenAiAdsEvent,
} from "./openai-ads-pixel";
export type {
  OpenAiAdsMeasureData,
  OpenAiAdsMeasureEventName,
  OpenAiAdsMeasureOptions,
} from "./openai-ads-pixel";
export {
  captureMarketingEvent,
  captureMarketingException,
  captureMarketingPageView,
  disableMarketingAnalytics,
  ensureGoogleTagManager,
  getPosthogClient,
  hasConsentedTagsOnPage,
  initializeMarketingAnalytics,
  isPosthogReady,
  reloadPage,
  syncGoogleConsentMode,
} from "./init";
export type { CaptureMarketingPageViewInput } from "./init";
export {
  EXPERIMENT_CONTROL_VARIANT,
  EXPERIMENT_OTP_VARIANT,
  EXPERIMENT_TRUST_VARIANT,
  WEBSITE_VOC_MESSAGING_FLAG,
} from "./experiments.constants";
export type {
  ExperimentVariantKey,
  WebsiteExperimentFlagKey,
} from "./experiments.constants";
export {
  getActiveWebsiteExperimentProperties,
  readExperimentVariant,
  useExperimentVariant,
} from "./experiments";
export {
  buildPosthogPageViewProperties,
  POSTHOG_PAGEVIEW_EVENT,
  RIVETAI_ANALYTICS_SURFACE,
} from "./surface";
export type { RivetaiAnalyticsSurface } from "./surface";
export {
  appendAttributionToUrl,
  isFrontendAppUrl,
} from "./append-attribution-to-url";
export {
  MARKETING_ATTRIBUTION_PARAM_KEYS,
  persistMarketingAttributionParams,
  readPersistedMarketingAttributionParams,
  readMarketingAttributionParams,
  readMarketingUtmParams,
  resolveMarketingAttributionParams,
  type MarketingAttributionParams,
  type MarketingUtmParams,
} from "./utm-params";
